import { Injectable, Injector } from '@angular/core';
import { InjectorService } from '../injector/injector.service';
import { EnvService } from 'src/app/shared/common/services/env.service';
import { CheckinHttpClient } from 'src/app/shared/services/http/http-client.service';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private http: CheckinHttpClient;
  private urlAnalytics: string;
  private config: ConfigService;

  constructor() {
    const injector: Injector = InjectorService.get();

    this.config = injector.get(ConfigService);
    const env: EnvService = injector.get(EnvService);

    Object.assign(this, {
      http: injector.get(CheckinHttpClient),
      urlAnalytics: `${env.endpoint}/v2/analytics`
    });
  }

  public initCheckin(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'Init',
      eventLabel: this.getStepsConfiguration()
    };
    this.sendEvent(params);
  }
  ​
  public closeCheckin(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'Finish',
      eventLabel: this.getStepsConfiguration()
    };​
    this.sendEvent(params);
  }

  public countryAgeSuccess(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'CountryAge_Success',
      eventLabel: this.getStepsConfiguration()
    };
    this.sendEvent(params);
  }

  public selectDocumentSucces(documentType): void {
    const stepsConfiguration = this.getStepsConfiguration();
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'SelectDocument_Success',
      eventLabel: `${stepsConfiguration}/${documentType}`
    };
    this.sendEvent(params);
  }

  public selectUploadType(photoOrUploadType): void {
    const stepsConfiguration = this.getStepsConfiguration();
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'PhotoOrUpload_Success',
      eventLabel: `${stepsConfiguration}/${photoOrUploadType}`
    };
    this.sendEvent(params);
  }

  public uploadDocumentSucces(documentType: string, photoOrUploadType: string): void {
    const stepsConfiguration = this.getStepsConfiguration();
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'DocumentPhoto_Success',
      eventLabel: `${stepsConfiguration}/${documentType}/${photoOrUploadType}`
    };
    this.sendEvent(params);
  }

  public selfiePhotoSuccess(documentType): void {
    const stepsConfiguration = this.getStepsConfiguration();
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'SelfiePhoto_Success',
      eventLabel: `${stepsConfiguration}/${documentType}`
    };
    this.sendEvent(params);
  }

  public sendFormSuccess(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'Form_Success',
      eventLabel: this.getStepsConfiguration()
    };
    this.sendEvent(params);
  }

  public addCardSuccess(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'AddCard_Success',
      eventLabel: this.getStepsConfiguration()
    };
    this.sendEvent(params);
  }

  public signDocumentsSuccess(): void {
    const params = {
      eventCategory: 'Checkin_Process',
      eventAction: 'SignDocuments_Success',
      eventLabel: this.getStepsConfiguration()
    };
    this.sendEvent(params);
  }

  public openCheckin(project): void {
    const params = {
      eventCategory: 'Checkin_Open',
      eventAction: 'Open',
      eventLabel: project
    };
    this.sendEvent(params);
  }

  public openDelegation(): void {
    const params = {
      eventCategory: 'Checkin_Delegation',
      eventAction: 'Init',
      eventLabel: ''
    };
    this.sendEvent(params);
  }

  public delegationSuccess(): void {
    const params = {
      eventCategory: 'Checkin_Delegation',
      eventAction: 'Finish',
      eventLabel: ''
    };
    this.sendEvent(params);
  }

  private sendEvent(params): void {
    params.customDimentions = {
      showProcessInfo : 'A'
    };

    const req = this.http.post(`${this.urlAnalytics}/event`, params).pipe(
      catchError((error: any) => throwError(error || 'Server error'))
    ).subscribe(() => {
      req.unsubscribe();
    });
  }

  private getStepsConfiguration() {
    const [step1, step2, step3, step4, step5] = [
      +this.config.checkin.config.isOcrActivated,
      1,
      +this.config.checkin.config.showTravelInfoOnWizard,
      +this.config.checkin.config.isCreditCardRequired,
      +Object.values(this.config.checkin.config.documentsId).some(val => val !== null)
    ];

    return `step1:${step1},step2:${step2},step3:${step3},step4:${step4},step5:${step5}`;
  }
}
